// Public booking entry contract (UI-20261020-003). Booking buttons point at the
// dedicated training page with `#book`; that page opens its hero booking panel
// and selects `?cohort=` when it is one of its bookable dates. `ref` carries the
// partner/referral code the page already reads. The server builds the same
// shape in PublicTrainingLocation#booking_entry_path.
export const BOOKING_ENTRY_HASH = '#book'
export const BOOKING_PANEL_PATHS = Object.freeze(['/program', '/portugal-pilates-teacher-training'])

// Same shape as ReferralCode.normalize (`RM-AB12CD34` keeps its hyphen); a
// value no referral/partner code can have is dropped rather than rewritten.
const normalizeCode = code => {
  const normalized = String(code || '').trim().toUpperCase().replace(/\s+/g, '-')
  return /^[A-Z0-9_-]{1,64}$/.test(normalized) ? normalized : ''
}
const COHORT_KEY = /^[a-z0-9-]{1,64}$/

// Adds a referral code without disturbing an existing query or `#book` hash.
export function withReferralCode(href, code) {
  const normalized = normalizeCode(code)
  if (!href || !normalized) return href
  const url = new URL(href, 'https://rooted.invalid')
  if (!url.searchParams.has('ref')) url.searchParams.set('ref', normalized)
  return url.origin === 'https://rooted.invalid' ? `${url.pathname}${url.search}${url.hash}` : url.toString()
}

export function bookingEntryHref(path, { cohortKey = '', code = '' } = {}) {
  const url = new URL(path, 'https://rooted.invalid')
  if (cohortKey && COHORT_KEY.test(cohortKey)) url.searchParams.set('cohort', cohortKey)
  url.hash = BOOKING_ENTRY_HASH
  return withReferralCode(`${url.pathname}${url.search}${url.hash}`, code)
}

// Returns the parsed same-origin booking entry URL, or null for any other link.
export function bookingEntryUrl(href, currentUrl) {
  if (!href) return null
  try {
    const url = new URL(href, currentUrl)
    return url.origin === new URL(currentUrl).origin && url.hash === BOOKING_ENTRY_HASH &&
      BOOKING_PANEL_PATHS.includes(url.pathname) ? url : null
  } catch {
    return null
  }
}

export function bookingEntryCohortKey(url) {
  const value = url?.searchParams?.get('cohort') || ''
  return COHORT_KEY.test(value) ? value : null
}
